import React from 'react';
import { Outlet } from 'react-router-dom';

function CreateScene() {
  return <Outlet />;
}

export default CreateScene;
